export enum VaroCategories {
  ACCOUNT_MANAGEMENT = 'account_management',
  APP_UPDATE = 'app_update',
  APPLICATION = 'application',
  CARD = 'card',
  CHECKING = 'checking',
  CREDIT_SCORE = 'credit_score',
  DCF = 'dcf',
  DEPOSIT_CASH = 'deposit_cash',
  DIRECT_DEPOSIT = 'direct_deposit',
  EXTERNAL_ACCOUNT = 'external_account',
  INCENTIVE = 'incentive',
  LOGIN = 'login',
  MARKETING = 'marketing',
  MOBILE_CHECK_DEPOSIT = 'mobile_check_deposit',
  ONBOARDING = 'onboarding',
  PROFILE_SETTINGS = 'profile_settings',
  REFERRAL = 'referral',
  REWARDS = 'rewards',
  SAVINGS = 'savings',
  SERVICING = 'servicing',
  SETTINGS = 'settings',
  TAX_FILING = 'tax_filing',
  TRANSFER_MONEY = 'transfer_money',
  V2A = 'v2a',
  VARO_ADVANCE = 'varo_advance',
  VARO_BELIEVE = 'varo_believe',
  VARO_HOME = 'varo_home',
  VLOC = 'vloc',
  ZELLE = 'zelle',
}

export type VaroCategoriesType = VaroCategories;
